var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showSelect)?_c('v-select',{attrs:{"items":_vm.branchesList,"autocomplete":"","hide-details":_vm.hideDetails,"label":_vm.label,"clearable":_vm.clearable,"disabled":_vm.disabled},model:{value:(_vm.branchId),callback:function ($$v) {_vm.branchId=$$v},expression:"branchId"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc560906","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/BranchSelect.vue
// module id = 1850
// module chunks = 0